"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APosThemeMoodSchema = void 0;
const zod_1 = require("zod");
const background_schema_1 = require("./background.schema");
const text_schema_1 = require("./text.schema");
/**
 * One mood card on the kiosk home grid. `id` survives publish so a customer
 * who already started a blend session keeps the mood they selected even if
 * the operator publishes a theme change mid-session.
 */
exports.APosThemeMoodSchema = zod_1.z.object({
    id: zod_1.z.string().min(1),
    order: zod_1.z.number().int().min(0),
    enabled: zod_1.z.boolean().default(true),
    background: background_schema_1.APosThemeBackgroundSchema,
    foreground: background_schema_1.APosThemeForegroundSchema.default({ enabled: false, scale: 40 }),
    text: text_schema_1.APosThemeTextSchema,
    fragranceIds: zod_1.z.array(zod_1.z.string()).default([]),
});
//# sourceMappingURL=mood.schema.js.map